<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>insert_chart</mat-icon></div>
    <div class="at-header-text">
      <h2 class="cf-dlg-title">Cuadro de amortización</h2>
      <p class="cf-dlg-subtitle" *ngIf="name || account">{{ name }}{{ name && account ? ' · ' : '' }}{{ account }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Calculando amortización…"></app-loading-state>

  <ng-container *ngIf="ready">
    <div class="cf-dlg-body at-body">
      <div class="at-alert at-alert--error" *ngIf="loadError">
        <mat-icon>error</mat-icon>
        <span>No se pudo calcular el cuadro de amortización.</span>
      </div>

      <ng-container *ngIf="!loadError">
        <div class="at-kpis">
          <div class="at-kpi">
            <span class="at-kpi__label">Valor amortizable</span>
            <span class="at-kpi__value">{{ total | number:'1.2-2' }} €</span>
          </div>
          <div class="at-kpi at-kpi--accent">
            <span class="at-kpi__label">Amortizado hasta hoy</span>
            <span class="at-kpi__value">{{ acumulated | number:'1.2-2' }} €</span>
          </div>
          <div class="at-kpi">
            <span class="at-kpi__label">Pendiente</span>
            <span class="at-kpi__value">{{ rest | number:'1.2-2' }} €</span>
          </div>
        </div>

        <div class="at-alert" *ngIf="!groups.length">
          <mat-icon>info</mat-icon>
          <span>No hay cuotas de amortización. Revisa el coeficiente lineal y la fecha de compra.</span>
        </div>

        <div class="at-table-wrap" *ngIf="groups.length">
          <table class="at-table">
            <thead>
              <tr>
                <th>Año</th>
                <th>Mes</th>
                <th class="at-num">Importe</th>
              </tr>
            </thead>
            <tbody *ngFor="let group of groups; trackBy: trackByYear" [class.at-current]="isCurrent(group)">
              <tr class="at-year">
                <td colspan="2">{{ group.year }}</td>
                <td class="at-num">{{ group.total | number:'1.2-2' }} €</td>
              </tr>
              <tr *ngFor="let line of group.lines">
                <td></td>
                <td>{{ line.month }}</td>
                <td class="at-num">{{ line.amount | number:'1.2-2' }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button *ngIf="loadError" mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
      <button *ngIf="!loadError" mat-flat-button class="cf-dlg-btn-primary" (click)="export()">
        <mat-icon>file_download</mat-icon> Exportar Excel
      </button>
    </div>
  </ng-container>
</div>
